// Typelizer digest f9b466540c9cd46ac46d458feb10f1b0
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** GET /setup/start */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/setup/start', {}, options),
    method: 'get',
  }),

  /** POST /setup/start */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/setup/start', {}, options),
    method: 'post',
  }),
}
